import { useState } from "react";
import { Network, Plus, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { Input } from "../ui/input";
import { api, errMsg } from "../../lib/api";

export const TrustedIps = ({ ips, reload }) => {
  const [ip, setIp] = useState("");
  const [label, setLabel] = useState("");

  const add = async (e) => {
    e.preventDefault();
    try {
      const r = await api.post("/trusted-ips", { ip, label });
      toast.success(`IP ${r.data.ip} approved${r.data.devices_approved ? ` · ${r.data.devices_approved} pending device(s) approved` : ""}`);
      setIp(""); setLabel("");
      reload();
    } catch (err) { toast.error(errMsg(err)); }
  };
  const remove = async (t) => {
    if (!window.confirm(`Remove approved IP ${t.ip}? New devices from it will need approval again.`)) return;
    try { await api.delete(`/trusted-ips/${t.id}`); toast.success("IP removed"); reload(); } catch (err) { toast.error(errMsg(err)); }
  };

  return (
    <div className="glass rounded-3xl p-5 mb-5" data-testid="trusted-ips">
      <div className="flex items-center gap-2"><Network className="h-5 w-5 text-emerald-700" /><h3 className="text-lg font-bold text-emerald-950">Approved IP addresses</h3></div>
      <p className="text-xs text-slate-500 mt-1">Any new device signing in from an approved IP (e.g. a hotel's network) is approved automatically. Revoked devices stay blocked.</p>
      <form onSubmit={add} className="mt-4 flex flex-wrap gap-2">
        <Input data-testid="trusted-ip-input" required value={ip} onChange={(e) => setIp(e.target.value)} placeholder="IP address, e.g. 103.197.75.73" className="h-10 w-full sm:w-64 rounded-full bg-white" />
        <Input data-testid="trusted-ip-label-input" value={label} onChange={(e) => setLabel(e.target.value)} placeholder="Label, e.g. Grand Tamanna front desk" className="h-10 w-full sm:w-72 rounded-full bg-white" />
        <button data-testid="trusted-ip-add-button" className="h-10 px-4 rounded-full bg-emerald-900 text-amber-50 text-sm font-semibold hover:bg-emerald-800 flex items-center gap-2 transition-colors"><Plus className="h-4 w-4" /> Approve IP</button>
      </form>
      <div className="mt-4 flex flex-wrap gap-2">
        {ips.length === 0 && <span className="text-sm text-slate-500">No approved IPs yet.</span>}
        {ips.map((t) => (
          <span key={t.id} data-testid={`trusted-ip-${t.ip}`} className="inline-flex items-center gap-2 rounded-full border border-emerald-200 bg-emerald-50 pl-3 pr-1 py-1 text-sm">
            <span className="font-semibold text-emerald-900">{t.ip}</span>
            {t.label && <span className="text-xs text-slate-500">{t.label}</span>}
            <button data-testid={`trusted-ip-remove-${t.ip}`} onClick={() => remove(t)} className="h-7 w-7 grid place-items-center rounded-full text-slate-400 hover:bg-red-50 hover:text-red-600 transition-colors"><Trash2 className="h-3.5 w-3.5" /></button>
          </span>
        ))}
      </div>
    </div>
  );
};
